// extracted by mini-css-extract-plugin
export default {"variant":"VariantImg_variant__1MDQ3","variantImgBlock":"VariantImg_variantImgBlock__dOr33","varNumber":"VariantImg_varNumber__WKu9x","varTitle":"VariantImg_varTitle__jhHUa"};